import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './preferredVendors.state';
import getters from './preferredVendors.getters';
import actions from './preferredVendors.actions';
import mutations from './preferredVendors.mutations';

BaseStore.registerModule('preferredVendors', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('preferredVendors');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};